import { Theme, Typography, Box } from '@mui/material';
import { ReactNode } from 'react';

export type SidebarHeaderProps = {
  title: ReactNode;
  action?: ReactNode;
  sx?: object;
};

export const SidebarHeader = ({ title, action, sx }: SidebarHeaderProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: ({ palette }: Theme) => palette.primary.light,
        width: '100%',
        margin: '0 ',
        padding: '4px 16px',
        borderBottom: '1px solid rgba(0,0,0,0.08)',
        ...sx,
      }}
    >
      <Typography variant='caption' sx={{ fontWeight: 'bold', color: 'text.main' }}>
        {title}
      </Typography>
      {action ? <Box sx={{ ml: 2 }}>{action}</Box> : null}
    </Box>
  );
};
